import React from "react";

/** Route that redirects to the support page */
export const support: React.FC = () => {
  window.location.replace(process.env.REACT_APP_SUPPORT_URL || "");
  return null;
};

export default support;
